import {
  type analyticsadmin_v1beta,
  analyticsadmin_v1alpha,
} from "googleapis/build/src/apis/analyticsadmin";
import { z } from "zod";

export type GaStream =
  analyticsadmin_v1beta.Schema$GoogleAnalyticsAdminV1betaDataStream;

export type GaAccount =
  analyticsadmin_v1beta.Schema$GoogleAnalyticsAdminV1betaAccountSummary;

export type GaPropertySummary =
  analyticsadmin_v1alpha.Schema$GoogleAnalyticsAdminV1alphaPropertySummary;

export type GaAudience =
  analyticsadmin_v1alpha.Schema$GoogleAnalyticsAdminV1alphaAudience;

export const GoogleGaAudienceSchema = z.object({
  testGroupId: z.string().uuid(),
  audienceId: z.string().nullish(),
});

export type GoogleGaAudienceType = z.infer<typeof GoogleGaAudienceSchema>;
